"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _io = require("react-icons/io5");
var _maskValidations = require("./maskValidations");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(function DateVisualHelper({
  ...props
}) {
  let is__valid = true;
  const infos = getExplodedValidation(props.user_value, props.mask);
  const letters = Array.from(props.mask).map(function (letter, i) {
    let class_name = props.className + '__letter';
    if (infos[i] === true) {
      class_name += ' is-valid';
    } else if (infos[i] === false) {
      class_name += ' is-invalid';
      is__valid = false;
    }
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react.default.createElement("span", {
        key: 'i-' + i + '-l-' + letter,
        className: class_name,
        "aria-hidden": props.hide > i
      }, letter)
    );
  });
  let class_name = props.className || '';
  const Icon = props.invalid || !is__valid ? _io.IoWarningOutline : undefined;
  if (props.incomplete) class_name += ' is-incomplete';
  if (props.invalid || !is__valid) class_name += ' is-invalid';
  if (props.user_value?.length > 0) class_name += ' is-visible';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: class_name + ' u-no-select',
    "aria-hidden": "true"
  }, letters, Icon ? /*#__PURE__*/_react.default.createElement(Icon, {
    className: (props.className || '') + '-icon'
  }) : undefined);
});
let mask_numbers_chars = ['d', 'm', 'y', 'h', 's'];
mask_numbers_chars = mask_numbers_chars.concat(mask_numbers_chars.map(c => c.toUpperCase()));
function getExplodedValidation(value, mask) {
  return Array.from(mask).slice(0, (value || '').length).reduce(function (exploded, char, i) {
    if (mask_numbers_chars.includes(char) === false) {
      return {
        ...exploded,
        [i]: value[i] === char
      };
    }
    const isValid = _maskValidations.date_validations[mask] || _maskValidations.date_validations['DD/MM/YYYY'];
    exploded[i] = isValid(value, i);
    return exploded;
  }, {});
}
